export type PermissionCode = string;

export function extractPermissions(payload: any): PermissionCode[] {
  if (!payload) {
    return [];
  }

  const source = payload.permissions ?? payload.Permissions ?? [];
  if (!Array.isArray(source)) {
    return [];
  }

  return source
    .map((code) => (typeof code === "string" ? code.trim() : ""))
    .filter((code): code is PermissionCode => Boolean(code));
}

export function hasPermission(permissions: PermissionCode[] | null | undefined, code: PermissionCode): boolean {
  if (!permissions || permissions.length === 0) {
    return false;
  }
  return permissions.some((perm) => perm.localeCompare(code, undefined, { sensitivity: "accent" }) === 0);
}

export function hasAnyPermission(permissions: PermissionCode[] | null | undefined, codes: PermissionCode[]): boolean {
  if (!codes.length) {
    return true;
  }
  return codes.some((code) => hasPermission(permissions, code));
}
